import { useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { Box, CircularProgress, Typography } from '@mui/material';
import { useAuth } from '../contexts/AuthContext';

/**
 * Auth callback page that handles OIDC redirect
 * Receives tokens from backend and stores them
 */
export const AuthCallbackPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { handleOidcCallback } = useAuth();

  useEffect(() => {
    const accessToken = searchParams.get('accessToken');
    const refreshToken = searchParams.get('refreshToken');
    const error = searchParams.get('error');

    if (error) {
      console.error('Auth callback error:', error);
      navigate('/login?error=' + error);
      return;
    }

    if (accessToken && refreshToken) {
      handleOidcCallback(accessToken, refreshToken)
        .then(() => {
          navigate('/');
        })
        .catch((err) => {
          console.error('Failed to handle OIDC callback:', err);
          navigate('/login?error=authentication_failed');
        });
    } else {
      navigate('/login?error=missing_tokens');
    }
  }, [searchParams, navigate, handleOidcCallback]);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        gap: 2,
      }}
    >
      <CircularProgress />
      <Typography variant="body1" color="text.secondary">
        Autentiserer...
      </Typography>
    </Box>
  );
};

export default AuthCallbackPage;
